import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "d-row" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "employeeid"
}
const _hoisted_5 = { class: "approval-body" }
const _hoisted_6 = { class: "buttons" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "user-detail"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "d-row approval-detail"
}

import UserTable from "@/components/tables/UserTable.vue";
import ReportTable from "@/components/tables/ReportTable.vue";
import OvertimeOverview from "@/components/OvertimeOverview.vue";
import MonthlyHistory from "@/components/MonthlyHistory.vue";
import { onBeforeMount, onUnmounted, reactive } from "vue";
import { useUserStore } from "@/stores/user";
import TileCard from "@/components/util/TileCard.vue";
import { useReportingMonthStore } from "@/stores/reporting";
import { Authorization } from "@/services/authenticate";
import { useVfm } from "vue-final-modal";
import LockModal from "@/components/modals/LockModal.vue";
import { MonthlyApprovalItem,  ApprovalStatus, } from "@/services/entities/Approval/MonthlyApprovalItem";
import { useApprovalStore } from "@/stores/approval";
import { useOvertimeStore } from "@/stores/overtime";
import ApprovalModal from "@/components/modals/ApprovalModal.vue";
import { showSuccess, showToastError } from "@/toastification";
import { UserItem, UserRole } from "@/services/entities/UserItem";
import Popper from "vue3-popper";
import AdminLockModal from "@/components/modals/AdminLockModal.vue";
import { UserApproval } from "@/services/entities/Approval/UserApproval";
import { useAdminLockStore } from "@/stores/adminLock";
import { isDateBeforeOther as isDateBeforeThat } from "@/common/date";
import MonthSelector from "@/components/util/MonthSelector.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApprovalsView',
  setup(__props) {

const vfm = useVfm();
const lockModalId = Symbol("lockModalId");
const approvalModalId = Symbol("approvalModalId");
const adminLockModalId = Symbol("adminLockModalId");

const state = reactive({
  date: { year: new Date().getFullYear(), month: new Date().getMonth() },
  loadDetail: false,
  selectedEmails: [] as string[],
  selectedApprovedUsers: [] as UserApproval[],
  dailyCommitment: 0,
  detailUser: null as UserItem | null,
  saving: false,
});

const userStore = useUserStore();
const reportingStore = useReportingMonthStore();
const approvalStore = useApprovalStore();
const overtimeStore = useOvertimeStore();
const adminLockStore = useAdminLockStore();

onUnmounted(() => {
  reportingStore.clearReportingMonth();
});

async function sendReminder() {

  const confirmed = confirm(`Are you sure you want to send a reminder to ${state.selectedEmails.length} selected ${state.selectedEmails.length == 1 ? "person" : "people"}?`);
  if (confirmed) {
    const url = "https://prod-00.westeurope.logic.azure.com:443/workflows/dd227ea9900041eaae9b822de2517584/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=KK5a8ljyZBN_umq9cta_toYb2YjvdyzA_upCfNyhjOs";
    const body = {
      selectedEmails: state.selectedEmails
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
      });

      if (response.ok) {
        showSuccess("Reminder sent successfully");
      } else {
        console.error("Failed to send reminder");
        showToastError("Failed to send reminder");
      }
    } catch (error) {
      console.error("An error occurred while sending the reminder:", error);
      showToastError("An error occurred while sending the reminder");
    }
  }
}

function openAdminLockModal() {
  vfm.open(adminLockModalId);
}

async function doAdminUnlock() {
  try
  {      
    let months = state.selectedApprovedUsers.map(a => a.monthlyApprovalItem);
    months.forEach(m => {
      m.isLocked = false;
    });
    await adminLockStore.updateAdminLock(months, Authorization.id);  
  }
  catch (error)
  {
    console.error("Error during admin unlock:", error);
    showToastError("Failed to unlock users");
  }
  vfm.close(adminLockModalId);
  refreshUsers();
  renewTable();
}

async function doAdminLock() {
  try
  {
    let months = state.selectedApprovedUsers.map(a => a.monthlyApprovalItem);
    months.forEach(m => {
      m.isLocked = true;
    });
    await adminLockStore.updateAdminLock(months, Authorization.id);
  }
  catch (error)
  {
    console.error("Error during admin lock:", error);
    showToastError("Failed to lock users");
  }
  vfm.close(adminLockModalId);
  refreshUsers();
  await renewTable();
}


function isAdmin(): boolean {
  let currentRole = userStore.getUserRole;
  let result = currentRole === UserRole.Administrator;  
  return result;
}

function isAdminLocked(): boolean {
  return adminLockStore.getAll?.isLocked ?? false;
}

function selection(selectedData: any[]) {
  state.selectedEmails = selectedData.map(a => a.userItem.email);
  state.selectedApprovedUsers = selectedData
      .filter(a => a.approvalStatus.name === "Approved")
      .sort((a, b) => a.userItem.email.localeCompare(b.userItem.email));
}

async function onSelectedMonthChanged(newDate: any) {
  state.date = newDate;
  await renewTable()
}

async function loadReportTable(user: UserItem) {
  state.loadDetail = true;
  state.detailUser = user;
  await reportingStore.loadReportingMonth(
    state.date.year,
    state.date.month + 1,
    user.id    
  );  
  
  state.dailyCommitment = user.dailyCommitments
                            .filter(a => isDateBeforeThat(a, state.date))
                            .sort((a, b) => b.month - a.month).sort((a, b) => b.year - a.year)[0]?.hours ?? 0;                           

  await overtimeStore.loadOvertimeModel(
    state.date.year,
    state.date.month + 1,
    user.id
  );
  await adminLockStore.loadAdminLock(
    state.date.year,
    state.date.month + 1,
    user.id
  );
}

async function renewTable() {
  await userStore.loadApproval(
    state.date.year,
    state.date.month + 1,
    Authorization.id
  );  
  if (state.detailUser) {
    await loadReportTable(state.detailUser as UserItem);  
  }
}

async function refreshUsers() {
  vfm.close(lockModalId);
  await userStore.loadApproval(
    state.date.year,
    state.date.month + 1,
    Authorization.id
  );
}

async function createMonthlyApprovalItem(status: ApprovalStatus, text: string) {
  return {
    year: state.date.year,
    month: state.date.month + 1,
    comment: text,
    userId: reportingStore.getAll.userId,
    status,
  } as MonthlyApprovalItem;
}

async function saveAndLoadApproval(status: ApprovalStatus, text: string) {
  const mA = await createMonthlyApprovalItem(status, text);
  await approvalStore.saveApproval(mA, Authorization.id);
  const tasks = [
    userStore.loadApproval(
      state.date.year,
      state.date.month + 1,
      Authorization.id
    ),
    reportingStore.loadReportingMonth(mA.year, mA.month, mA.userId),
    overtimeStore.loadOvertimeModel(
      state.date.year,
      state.date.month + 1,
      mA.userId
    ),
  ];
  approvalStore.loadApproval(mA.year, mA.month, mA.userId);
  await Promise.all(tasks);
}

async function approve(text: string) {
  await saveAndLoadApproval(ApprovalStatus.Approved, text);
}

async function reject(text: string) {
  await saveAndLoadApproval(ApprovalStatus.Rejected, text);
}

function checkForApproval() {
  return (
    (reportingStore.getAll.status.id as ApprovalStatus) ==
    ApprovalStatus.SentForApproval ||
    (reportingStore.getAll.status.id as ApprovalStatus) ==
    ApprovalStatus.Rejected
  );
}

async function save() {
  // Check if there are any lines without ActivityNumberId
  state.saving = true
  try
  {
    if (
      reportingStore.getAll.lines.some(
        (a) => (a.projectTypeId == 0 || a.projectTypeId == 1) && !a.activity
      )
    ) {
      showToastError("Please select activity for all projects");
      return;
    }
    // Group by project and activity, then count the number of lines, if more than 1, show error
    let grouped = reportingStore.getAll.lines.reduce((a, b) => {
      let key = `${b.project?.projectId}-${b.activity?.id}-${b.customActivity}`;
      if (!a[key]) {
        a[key] = 0;
      }
      a[key]++;
      return a;
    }, {} as { [key: string]: number });
    let errors = Object.keys(grouped).filter((a) => grouped[a] > 1);
    if (errors.length > 0) {
      showToastError(
        "There are multiple lines for the same project and activity"
      );
      return;
    }
    if (
      reportingStore.getAll.lines.some(
        (a) => a.projectTypeId > 90 || a.projectTypeId == 2
      )
    ) {
      reportingStore.getAll.lines.forEach((a) => {
        a.projectId = a.project?.projectId;
        if (a.activity) {
          a.activityNumberId = a.activity?.id;
        }
        if (a.projectTypeId > 90 || a.projectTypeId == 2) {
          a.activityTypeId = 0;
          a.activityNumberId =
            reportingStore.getAll.projects.find((b) => b.projectId == a.projectId)
              ?.activityNumbers[0]?.id ?? "";
        }
      });
    }

    reportingStore.getAll.lines.forEach((a) => {
      a.days.forEach((b) => {
        if (typeof b.hours == "string") {
          b.hours = null;
        }
      });
    });

    reportingStore.getAll.actionAuthor = Authorization.id;
    reportingStore.getAll.lines = reportingStore.getAll.lines.filter(
      (a) => a.project
    );
    
    await reportingStore.saveMonth(reportingStore.getAll);

    await overtimeStore.loadOvertimeModel(
      state.date.year,
      state.date.month + 1,
      reportingStore.getAll.userId
    );
    await userStore.loadApproval(
      state.date.year,
      state.date.month + 1,
      Authorization.id
    );
  } finally {
    state.saving = false;
  }
}

onBeforeMount(async () => {
  //await userStore.loadForManager(Authorization.id);
  await userStore.loadApproval(
    state.date.year,
    state.date.month + 1,
    Authorization.id
  );
});
onUnmounted(() => {
  reportingStore.clearReportingMonth();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "title" }, "Approvals", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(MonthSelector, { onMonthSelected: onSelectedMonthChanged }),
        _createElementVNode("span", _hoisted_3, [
          _createTextVNode(_toDisplayString(state.detailUser?.fullName), 1),
          (state.detailUser)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Id: " + _toDisplayString(state.detailUser?.employeeId), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(TileCard, {
        id: "approval-table",
        class: "user-table",
        loaded: _unref(userStore).getForApprovalLoaded
      }, {
        body: _withCtx(() => [
          _createVNode(UserTable, {
            onDetail: loadReportTable,
            data: _unref(userStore).getForApproval,
            onSelection: selection
          }, null, 8, ["data"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "accent",
              onClick: sendReminder,
              disabled: state.selectedEmails.length == 0
            }, "Send reminder", 8, _hoisted_7),
            _createVNode(_unref(Popper), {
              class: "tooltip",
              content: "Admin locks/unlocks the selected users with Approved/Locked status.",
              hover: "",
              openDelay: "200",
              closeDelay: "100"
            }, {
              default: _withCtx(() => [
                (isAdmin())
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "accent",
                      onClick: openAdminLockModal,
                      disabled: state.selectedApprovedUsers.length == 0
                    }, "Admin locks", 8, _hoisted_8))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(AdminLockModal, {
              "modal-id": _unref(adminLockModalId),
              onClose: _cache[0] || (_cache[0] = () => _unref(vfm).close(_unref(adminLockModalId))),
              onLock: doAdminLock,
              users: state.selectedApprovedUsers,
              onUnlock: doAdminUnlock
            }, null, 8, ["modal-id", "users"])
          ])
        ]),
        _: 1
      }, 8, ["loaded"]),
      (state.loadDetail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(TileCard, {
              id: "report-table",
              loaded: !_unref(reportingStore).getAllLoaded
            }, {
              body: _withCtx(() => [
                _createVNode(ReportTable, {
                  reportingMonth: _unref(reportingStore).getAll,
                  "daily-commitment": state.dailyCommitment,
                  readonly: state.saving,
                  saving: state.saving
                }, _createSlots({ _: 2 }, [
                  (!isAdminLocked())
                    ? {
                        name: "buttons",
                        fn: _withCtx(() => [
                          checkForApproval
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createTextVNode(_toDisplayString(_unref(ApprovalStatus)[_unref(reportingStore).getAll.status.id]) + " ", 1),
                                _createElementVNode("button", {
                                  class: "accent",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(vfm).open(_unref(approvalModalId)))),
                                  disabled: state.saving
                                }, " Approve / Reject ", 8, _hoisted_11)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            onClick: save,
                            disabled: state.saving
                          }, "Save", 8, _hoisted_12),
                          _createElementVNode("button", {
                            onClick: _cache[2] || (_cache[2] = () => _unref(vfm).open(_unref(lockModalId))),
                            disabled: state.saving
                          }, "Edit locks", 8, _hoisted_13)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["reportingMonth", "daily-commitment", "readonly", "saving"])
              ]),
              _: 1
            }, 8, ["loaded"]),
            (!_unref(reportingStore).getAllLoaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(OvertimeOverview, {
                    overtimeModel: _unref(overtimeStore).getModel,
                    loaded: _unref(overtimeStore).getModelLoaded
                  }, null, 8, ["overtimeModel", "loaded"]),
                  _createVNode(MonthlyHistory, {
                    year: state.date.year,
                    month: state.date.month,
                    userId: _unref(reportingStore).getAll.userId
                  }, null, 8, ["year", "month", "userId"]),
                  _createVNode(LockModal, {
                    locks: _unref(reportingStore).getAll.lockHistoryItems,
                    userName: _unref(reportingStore).getAll.userName,
                    userId: _unref(reportingStore).getAll.userId,
                    year: state.date.year,
                    month: state.date.month + 1,
                    "modal-id": _unref(lockModalId),
                    onClose: _cache[3] || (_cache[3] = () => _unref(vfm).close(_unref(lockModalId))),
                    onRefreshUsers: refreshUsers
                  }, null, 8, ["locks", "userName", "userId", "year", "month", "modal-id"]),
                  _createVNode(ApprovalModal, {
                    "modal-id": _unref(approvalModalId),
                    onApprove: approve,
                    onReject: reject
                  }, null, 8, ["modal-id"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})